import {
  ITEM_HEIGHT,
  LABEL_ITEM_CLASSNAME,
  LEGEND_BUTTON_WIDTH,
  LEGEND_ICON_WIDTH,
} from '../../legend/categorical/constants.js';
import {
  CONTAINER_PADDING,
  DEFAULT_ITEM_THICKNESS as RANGE_LEGEND_SEGMENT_SIZE,
} from '../../legend/range/constants.js';

/**
 * Calculates the max size of the visible legend item in a categorical legend with
 * the horizontal layout.
 * @param node -
 * @param height -
 */
export const getMaxItemSizeForCategoricalHorizontal = (
  node: HTMLDivElement,
  height: number,
): number => {
  const textWidths: number[] = [];
  const nrOfVisibleItems = Math.round(height / ITEM_HEIGHT.value);

  const nodes = node.getElementsByClassName(LABEL_ITEM_CLASSNAME);

  for (const node of Array.from(nodes).slice(0, nrOfVisibleItems)) {
    textWidths.push(
      node.getBoundingClientRect().width +
        LEGEND_BUTTON_WIDTH +
        LEGEND_ICON_WIDTH,
    );
  }

  return Math.max(...textWidths);
};

/**
 * Calculates the height of the legend, when it is placed on the bottom, in
 * order to show 1.5 rows the horizontal layout.
 */
export const getSizeForCategoricaVertical = (): number => {
  const oneAndHalfRow = ITEM_HEIGHT.value + ITEM_HEIGHT.value / 2;
  const resizerPadding = 10;

  return oneAndHalfRow + resizerPadding;
};

/**
 * Returns the max size in pixels, of the range legend segment's
 * label, when the legend is positioned on the right of the chart.
 * @param node -
 */
export const getMaxLabelForRangeHorizontal = (node: HTMLDivElement): number => {
  const textWidths: number[] = [];

  const nodes = node.getElementsByTagName('g');

  for (const node of Array.from(nodes)) {
    textWidths.push(node.getBoundingClientRect().width);
  }

  return Math.max(...textWidths) + CONTAINER_PADDING * 2;
};

export const getLabelsHeightForRangeBottom = (node: HTMLDivElement): number => {
  const nodes = node.getElementsByTagName('g');
  const firstLabel = Array.from(nodes)?.[0];

  // all labels have the same height so we can use the 1st
  return firstLabel?.getBoundingClientRect().height + RANGE_LEGEND_SEGMENT_SIZE;
};
